/**
 * Destinatário FluxZap no extrato: Patient ou Person.
 * Não substitui patientIdFromReference (finder/aniversário continuam só Patient).
 */

export type FluxZapRecipientResourceType = "Patient" | "Person";

export type FluxZapRecipientRef = {
  resourceType: FluxZapRecipientResourceType;
  id: string;
  /** Ex.: Patient/{id} ou Person/{id}. */
  reference: string;
};

const PATIENT_PREFIX = "Patient/";
const PERSON_PREFIX = "Person/";

export function parseFluxZapRecipientReference(
  reference: string | undefined | null,
): FluxZapRecipientRef | undefined {
  const trimmed = String(reference ?? "").trim();
  if (!trimmed) return undefined;

  if (trimmed.startsWith(PERSON_PREFIX)) {
    const id = trimmed.slice(PERSON_PREFIX.length).trim();
    if (!id) return undefined;
    return { resourceType: "Person", id, reference: `${PERSON_PREFIX}${id}` };
  }

  if (trimmed.startsWith(PATIENT_PREFIX)) {
    const id = trimmed.slice(PATIENT_PREFIX.length).trim();
    if (!id) return undefined;
    return { resourceType: "Patient", id, reference: `${PATIENT_PREFIX}${id}` };
  }

  return undefined;
}

export function isRegisteredClientRecipient(
  summary: { recipientResourceType?: FluxZapRecipientResourceType } | undefined,
): boolean {
  return summary?.recipientResourceType === "Person";
}
